export const STATUS_COLORS = {
  "IN TRIAL": "bg-blue-100 text-blue-700",
  "IN CORRECTION": "bg-rose-100 text-rose-700",
  "READY TO USE": "bg-yellow-100 text-yellow-700",
  "CLEANING PROCESS": "bg-coral-100 text-coral-700",
  NITRIDING: "bg-orange-100 text-orange-700",
  "NEW ORDERED": "bg-indigo-100 text-indigo-700",
  BROCKEN: "bg-red-100 text-red-700",
  "NEWLY ARRIVED": "bg-gray-100 text-gray-700",
  "IN PRODUCTION": "bg-purple-100 text-purple-700",
  COMPLETE: "bg-sky-100 text-sky-700",
  RETURNED: "bg-pink-100 text-pink-700",
  AVAILABLE: "bg-green-100 text-green-700",
};
